define('lq/runtimeUrl',[
    'jquery',
    'underscore'
], function ($, _) {
    'use strict';

    var RuntimeUrl = function (queryString) {
        this.queryString = queryString;
    };

    RuntimeUrl.parameters = {
        language: 'lq_lang'
    };

    RuntimeUrl.prototype.overwriteLicquidParameter = function (parameter, value) {
        var self = this;
        _.each(_.keys(RuntimeUrl.parameters), function (paramName) {
            if (RuntimeUrl.parameters[paramName] === parameter)
                self.queryString.updateParameter(parameter, value)
        });
    };

    RuntimeUrl.prototype.prepare = function (url, queryStringObject) {
        queryStringObject = queryStringObject || {};

        var self = this;
        _.each(_.keys(RuntimeUrl.parameters), function (paramName) {
            var parameter = RuntimeUrl.parameters[paramName];
            var value = self.queryString.getValueOf(parameter);
            if (value !== undefined) queryStringObject[parameter] = value;
        });

        if (_.keys(queryStringObject).length)
            return url + '?' + $.param(queryStringObject);
        return url;
    };

    RuntimeUrl.prototype.openUrl = function (targetUrl, openBlank) {
        if (openBlank) {
            window.open(targetUrl, "_blank");
        } else {
            window.location.href = targetUrl;
        }
    };

    return RuntimeUrl;
});
